// src/services/lawUpdates.js

// Your API base URL - adjust based on your setup
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export const fetchLawUpdates = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/news-flash`);
    if (!response.ok) {
      throw new Error('Failed to fetch news flash');
    }
    
    const data = await response.json();
    if (data.success && data.newsFlashes) {
      return data.newsFlashes;
    }
    return [];
  } catch (error) {
    console.error('Error fetching law updates:', error);
    // Return empty array on error to prevent app from crashing
    return [];
  }
};

export const updateNewsFlash = async (newsData, credentials) => {
  try {
    // Use provided credentials
    const adminToken = btoa(`${credentials.email}:${credentials.password}`);
    
    const response = await fetch(`${API_BASE_URL}/api/news-flash`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Admin-Token': adminToken
      },
      body: JSON.stringify({
        message: newsData.lawName,
        state: newsData.state || ''
      }),
    });

    if (!response.ok) {
      throw new Error('Failed to update news flash');
    }

    const data = await response.json();
    return data.newsFlash;
  } catch (error) {
    console.error('Error updating news flash:', error);
    throw error;
  }
};

export const dismissNewsFlash = async (id) => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/news-flash/${id}`, {
      method: 'DELETE',
    });

    if (!response.ok) {
      throw new Error('Failed to dismiss news flash');
    }

    return await response.json();
  } catch (error) {
    console.error('Error dismissing news flash:', error);
    throw error;
  }
};